import { api } from '@/lib/api'
import type {
  CollabUser,
  CreateThreadInput,
  EditMessageInput,
  MentionItem,
  Message,
  PostMessageInput,
  Thread,
  ThreadStatus,
} from './types'

/** Ścieżki /api/collab trafiają do proxy w easycrm backend, który forwarduje do collab backendu. */

export async function listThreads(entityRef: string, status?: ThreadStatus): Promise<Thread[]> {
  const params = new URLSearchParams({ entityRef })
  if (status) params.set('status', status)
  const r = await api.get<Thread[]>(`/api/collab/threads?${params.toString()}`)
  return r.data
}

export async function createThread(input: CreateThreadInput): Promise<Thread> {
  const r = await api.post<Thread>('/api/collab/threads', input)
  return r.data
}

export async function setThreadStatus(threadId: number, status: ThreadStatus): Promise<void> {
  await api.patch(`/api/collab/threads/${threadId}/status`, { status })
}

export async function listMessages(threadId: number): Promise<Message[]> {
  const r = await api.get<Message[]>(`/api/collab/threads/${threadId}/messages`)
  return r.data
}

export async function postMessage(threadId: number, input: PostMessageInput): Promise<Message> {
  const r = await api.post<Message>(`/api/collab/threads/${threadId}/messages`, input)
  return r.data
}

export async function editMessage(messageId: number, input: EditMessageInput): Promise<void> {
  await api.patch(`/api/collab/messages/${messageId}`, input)
}

export async function deleteMessage(messageId: number): Promise<void> {
  await api.delete(`/api/collab/messages/${messageId}`)
}

export async function inviteParticipants(threadId: number, userIds: number[]): Promise<void> {
  await api.post(`/api/collab/threads/${threadId}/participants`, { userIds })
}

export async function removeParticipant(threadId: number, userId: number): Promise<void> {
  await api.delete(`/api/collab/threads/${threadId}/participants/${userId}`)
}

export async function markRead(threadId: number, lastReadMessageId: number): Promise<void> {
  await api.post(`/api/collab/threads/${threadId}/read`, { lastReadMessageId })
}

export async function myMentions(): Promise<MentionItem[]> {
  const r = await api.get<MentionItem[]>('/api/collab/me/mentions')
  return r.data
}

export async function unread(entityRef: string): Promise<{ count: number }> {
  const params = new URLSearchParams({ entityRef })
  const r = await api.get<{ count: number }>(`/api/collab/me/unread?${params.toString()}`)
  return r.data
}

export async function searchUsers(q: string): Promise<CollabUser[]> {
  const params = new URLSearchParams({ q })
  const r = await api.get<CollabUser[]>(`/api/collab/users?${params.toString()}`)
  return r.data
}

export async function fetchWsTicket(): Promise<string> {
  const r = await api.post<{ ticket: string }>('/api/collab/ws-ticket')
  return r.data.ticket
}

export type UploadedAttachment = {
  id: number
  filename: string
  contentType: string
  sizeBytes: number
}

/** Draft-upload: wrzuca plik do collab (przez proxy easy), zwraca id do podpięcia przy POST message. */
export async function uploadAttachment(file: File): Promise<UploadedAttachment> {
  const form = new FormData()
  form.append('file', file)
  // Nadpisanie domyślnego application/json - axios v1 przy FormData dokłada boundary.
  const r = await api.post<UploadedAttachment>('/api/collab/attachments', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return r.data
}
